import { iPaymentHistoryResponse } from "../presentation/interfaces/payment-history.interface";
import { createApiError, normalizeToApiError } from "./error.service";
import { interceptorFetch } from "./interceptor.service";

export async function getPaymentHistory(employeeId: number, limit: number, offset: number, token: string, updateToken: (newToken: string) => void) {
    try {
        const response = await interceptorFetch(`transaction-history/employee/${employeeId}?limit=${limit}&offset=${offset}`, token, updateToken, { method: "GET" });

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({ message: 'Error fetching accounts' }));
            throw createApiError(errorData, response.status);
        }
        const data: iPaymentHistoryResponse = await response.json();
        return data;
    } catch (error) {
        throw normalizeToApiError(error);
    }
}